/**
 * Kontrolka odpowiedzialna za rysowanie wykresów słupkowych.
 * Dane w konfiguracji:
 *  container-id - id kontenera
 *  data - dane dla wykresu
 *  name-mapping - mapowanie danych w wykresie
 *  colors - kolory dla konkretnych partii danych
 * Funkcje:
 *  init() 
 *  prepareData() - przygotowanie danych w formie określonej przez plugin chart.js
 *  drawChart() - rysowanie wykresu za pomocą pluginu chart.js
 */
"use strict";
(function(global) {
    class LineChart {
        constructor(config) {
            this.settings = {
                colors: {
                    "1": "#ff6600",
                        "2": "#4bb4e6",
                        "3": "#fadc00",
                        "4": "#50be87",
                        "5": "#9164cd",
                        "6": "#ffb4e6",
                        "7": "#d54733"
                }
            };
            this.init(config);
        }

        init(config) {
            const settings = this.settings;
            let data;
            if (config["multidata"] === true) {
                data = this.prepareData(config, settings);
            } else {
                data = this.prepareSingleData(config, settings);
            }

            this.drawChart(config, data);

        }

        objectSize(object) {
            const keys = Object.keys(object);
            return keys.length;
        }

        colorLuminance(hex, lum) {
            hex = String(hex).replace(/[^0-9a-f]/gi, "");
            if (hex.length < 6) {
                hex = hex.replace(/(.)/g, '$1$1');
            }
            lum = lum || 0;
            let rgb = "#",
                c;
            for (let i = 0; i < 3; ++i) {
                c = parseInt(hex.substr(i * 2, 2), 16);
                c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                rgb += ("00" + c).substr(c.length);
            }
            return rgb;
        }

        prepareData(config, settings) {
            const data = config["data"];
            const xAxis = [];
            const dataSet = {};
            const me = this;
            let colorsCounter = 1;
            let color;
            let colorHighlight;
            let colorRepeat = 0;
            $.each(data, function(index, val) {
                xAxis.push(val.name);
                $.each(val.values, function(index, val) {
                    if (typeof dataSet[index] == 'undefined') {
                        dataSet[index] = [];
                    }
                    dataSet[index].push(val);
                });
            });

            const tmpDataSet = [];
            $.each(dataSet, function(index, val) {
                if (typeof config["colors"] != 'undefined') {
                    const tmp = config["colors"][index];
                    color = "rgba(" + tmp + ",0.9)";
                    colorHighlight = "rgba(" + tmp + ",1)";
                } else {
                    const tmp = settings["colors"][colorsCounter];
                    if (colorsCounter >= me.objectSize(settings["colors"])) {
                        colorsCounter = 1;
                        colorRepeat++;
                    }
                    const lum = (colorRepeat / 10);
                    color = me.colorLuminance(tmp, -lum);
                    // color = "rgba(" + tmp + ",0.9)";
                    colorHighlight = me.colorLuminance(tmp, -lum - 0.05);
                    colorsCounter++;
                }
                let name = index;
                if (typeof config["name_mapping"] != 'undefined') {
                    $.each(config["name_mapping"], function(index, val) {
                        if (name === index) {
                            name = val;
                        }
                    });
                }

                tmpDataSet.push({
                    label: name,
                    fillColor: color,
                    strokeColor: color,
                    pointColor: color,
                    pointStrokeColor: color,
                    pointHighlightFill: colorHighlight,
                    pointHighlightStroke: colorHighlight,
                    data: val
                });
            });

            return {
                labels: xAxis,
                datasets: tmpDataSet
            };
        }

        prepareSingleData(config, settings) {
            const data = config["data"];
            const columnsData = [];
            const xAxis = [];
            const me = this;
            const color = me.colorLuminance(settings["colors"][1], 0.1);
            const colorHighlight = settings["colors"][1];
            const name = data["name"];

            $.each(data["values"], function(index, val) {
                xAxis.push(index);
                columnsData.push(val)
            });

            return {
                labels: xAxis,
                datasets: [{
                    label: name,
                    fillColor: color,
                    strokeColor: color,
                    pointColor: color,
                    pointStrokeColor: color,
                    pointHighlightFill: colorHighlight,
                    pointHighlightStroke: colorHighlight,
                    data: columnsData
                }]
            };
        }

        drawChart(config, data) {
            const options = {
                scaleBeginAtZero: true,
                scaleShowGridLines: true,
                scaleGridLineColor: "rgba(0,0,0,0.05)",
                scaleGridLineWidth: 1,
                scaleShowHorizontalLines: true,
                scaleShowVerticalLines: true,
                bezierCurve: true,
                bezierCurveTension: 0.3,
                pointDot: true,
                pointDotRadius: 4,
                pointDotStrokeWidth: 1,
                pointHitDetectionRadius: 20,
                datasetStroke: true,
                datasetStrokeWidth: 2,
                datasetFill: false,
                legendTemplate: "<ul class=\"char-legend\"><% for (var i = 0; i < datasets.length; i++){%><li <%if(datasets[i].label){%>title=\"<%=datasets[i].label%>\"<%}%>><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><strong><%if(datasets[i].label){%><%=datasets[i].label%><%}%></strong></li><%}%></ul>"
            };
            const id = config["container-id"];
            const ctx = document.getElementById(id).getContext("2d");
            const myBarChart = new Chart(ctx).Line(data, options);
            if (config['show_legend']) {
                const legend = myBarChart.generateLegend();
                $('#' + id).parent().append(legend);
            }
        }
    }


    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Charts = global.NS.Charts || {};
    global.NS.Charts.LineChart = LineChart || {};

})(window);
